module.exports = __webpack_public_path__ + "img/Frame-35.c26bbbac.svg";